import { Card } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { isEmpty } from 'lodash';
import parse from 'html-react-parser';
import Pluralize from 'pluralize';
import { isEnquiryOption, openEnquiry } from './helpers';
import PriceDefinition from './price_definition';
import { optionShape, subOptionGroupShape } from './prop_types';

const OptionCard = ({ option, group }) => {
  const history = useHistory();
  const isEnquiry = isEnquiryOption(option);
  const qtConfigOptionTitle =
    group.type === 'accommodation-option-group'
      ? `${group.title} - ${option.title}`
      : option.title;
  const handleRedirect = () => {
    if (isEnquiry) {
      return openEnquiry(option.title, qtConfigOptionTitle);
    }
    if (!isEmpty(option.option_groups)) {
      // Need to redirect to sub-options page
      return history.push('/sub-option-groups', {
        option,
      });
    }
    if (option.resource_id) {
      // Redirect to booking form page
      return history.push('/booking-form', {
        bookableOption: option,
      });
    }
  };

  let buttonText = 'Select';
  if (isEnquiry) {
    buttonText = 'Enquire';
  } else if (group.enquiry_options_only) {
    buttonText = 'View options';
  }

  return (
    <Card className="booking-option-card my-4">
      <Card.Body>
        <Card.Title className="title-wrap">
          <h5 className="reset-text fw-bold mb-2 text-secondary">
            {option.title}
          </h5>
          <h6 className="reset-text fw-bold mb-3 text-tertiary">
            {option.price}
          </h6>
        </Card.Title>

        <div className="option-description mb-4 reset-text">
          {option.description ? parse(option.description) : ''}
        </div>

        <PriceDefinition list={option.price_definition} />

        {option.room_capacity && (
          <div className="option-description reset-text">
            Max {option.room_capacity}{' '}
            {Pluralize('person', option.room_capacity)} per room
          </div>
        )}

        <div className="mt-3">
          <button
            type="button"
            onClick={handleRedirect}
            className="btn btn-primary w-100"
          >
            {buttonText}
          </button>
        </div>
      </Card.Body>
    </Card>
  );
};

OptionCard.propTypes = {
  option: optionShape,
  group: subOptionGroupShape,
};

export default OptionCard;
